import { useEffect, useState } from "react";
import { useParams } from "react-router";
import { VENDOR_THEME_PREFIX_NAME } from "utils/constants";

export const useThemingPrefix = () => {
  const [vendorThemingPrefix, setVendorThemingPrefix] = useState("");

  const params = useParams();

  useEffect(() => {
    if (params[VENDOR_THEME_PREFIX_NAME]) {
      setVendorThemingPrefix(params[VENDOR_THEME_PREFIX_NAME]);
    }
  }, [params]);

  return vendorThemingPrefix;
};
